import { useState } from 'react';

const minDate = new Date(1900, 0, 1);
const maxDate = new Date();

const useDate = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [isValidDate, setIsValidDate] = useState<boolean>(false);

  return {
    selectedDate,
    isValidDate,
    setSelectedDate,
    setIsValidDate,
    minDate,
    maxDate,
  };
};

export default useDate;
